export default __webpack_public_path__ + "static/media/in_brandorodriguez.3a03ca30.svg";